export default "__VITE_ASSET__CVuuH9p0__"